export const FIND_TRIP_TABLE_COLUMNS = [
  'assetId',
  'tripStartTime',
  'driver',
  'duration',
  'distance',
  'eventCount',
  'previousRequests',
  'actions',
];
